export default __webpack_public_path__ + "static/media/business-login.4cbc41ec.png";